import React from 'react';
import PropTypes from 'prop-types';
import Heading from '@cotyorg/ccx-atoms/Heading/Heading';
import Picture from '@cotyorg/ccx-atoms/Picture';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import R from 'ramda';
import { VideoPlayer } from '@cotyorg/ccx-organism-video';
import {
  trackVideoPlayEvent,
  trackVideoMilestoneEvent,
} from '@cotyorg/ccx-utils/js/tracking/adobe-dtm/events/video';
import SectionHeader from '../../../atoms/SectionHeader';

export const HeaderSection = ({ images, videos, sectionHeading }) => (
  <div className="article-section article-section--padding-bottom">
    <div className="picture-width__full">
      <Picture
        alt={R.path([0, 'imageAlt'], images)}
        src={R.path([0, 'imageSrc'], images)}
        srcset={R.path([0, 'imageSrcSet'], images)}
      />
    </div>

    <div className="video-full-width">
      <VideoPlayer
        videosStoreDataKey="header"
        showControls={false}
        onProgress={({ url, duration, progress, videoMilestone }) =>
          trackVideoMilestoneEvent({
            url,
            duration,
            progress,
            videoMilestone,
            title: R.prop('name', videos),
          })
        }
        onPlay={({ url, duration, progress }) =>
          trackVideoPlayEvent({
            url,
            duration,
            progress,
            title: R.prop('name', videos),
          })
        }
        config={{
          youtube: {
            playerVars: {
              controls: 1,
            },
            embedOptions: {
              host: 'https://www.youtube-nocookie.com',
            },
          },
        }}
      />
    </div>

    <div className="grid-container">
      <div className="grid-x grid-margin-x">
        <div className="cell">
          <SectionHeader>
            <Heading level={2}>{R.prop('heading', sectionHeading)}</Heading>
          </SectionHeader>
          <Paragraph>{R.prop('introduction', sectionHeading)}</Paragraph>
        </div>
      </div>
    </div>
  </div>
);

HeaderSection.propTypes = {
  sectionHeading: PropTypes.objectOf(PropTypes.object),
  images: PropTypes.objectOf(PropTypes.array),
  videos: PropTypes.objectOf(PropTypes.array),
};
